// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// local
// views
import CustomDropdown from 'app/ui/commons/CustomDropdown';
import ErrorLabel from 'app/ui/commons/ErrorLabel';

// List of all brazillian states.
const STATES_LIST = [
    'AC',
    'AL',
    'AM',
    'AP',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MG',
    'MS',
    'MT',
    'PA',
    'PB',
    'PE',
    'PI',
    'PR',
    'RJ',
    'RN',
    'RO',
    'RR',
    'RS',
    'SC',
    'SE',
    'SP',
    'TO',
].map(state => ({ text: state, value: state }));

class DropdownBRState extends Component {
    render() {
        const { width, value, onChange, error, loading } = this.props;
        return (
            <CustomDropdown
                placeholder="UF"
                label={<ErrorLabel label="UF" error={error} />}
                selection
                width={width}
                options={STATES_LIST}
                value={value}
                onChange={onChange}
                error={error ? true : false}
                loading={loading}
            />
        );
    }
}

DropdownBRState.propTypes = {
    width: PropTypes.number.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    error: PropTypes.string,
    loading: PropTypes.bool,
};

export default DropdownBRState;
